export default __webpack_public_path__ + "static/873-2415912a046b7654f4e18cf7e2a64c32.gif";